import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RetentionPage } from '../screens/admin/RetentionPage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
});

export const Route = createFileRoute('/admin/retention')({
  validateSearch: searchSchema,
  component: RetentionPage,
});
